import { enumCatalogShareStatus } from '@ingenico/api-sdk-device-management-private-v2';
import type { EnumCatalogShareStatusApi } from '@ingenico/api-sdk-device-management-private-v2';
export const CatalogShareStatus = enumCatalogShareStatus;

export const CATALOG_SHARE_DEFAULT_MAX_USAGE_COUNT = 1;

export interface CatalogShareItem {
  readonly id: string;
  readonly version: string;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly status: EnumCatalogShareStatusApi;
  readonly recipients: string[];
  readonly errorMessage?: string;
}

export interface CatalogShareSearchResponse {
  readonly data: CatalogShareItem[];
  readonly total: number;
}
export enum CatalogShareDetailsStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  REVOKED = 'REVOKED',
}

export interface CatalogShareDetailsApi {
  readonly id: string;
  readonly versionNumber: string;
  readonly status: CatalogShareDetailsStatus;
  readonly creationDate: string;
  readonly createdBy: string;
  readonly activationDate?: string;
  readonly expirationDate?: string;
  readonly revocationDate?: string;
  readonly revokedBy?: string;
  readonly recipients: string[];
  readonly failureReason?: string;
}

export interface CatalogShareDetails {
  readonly id: string;
  readonly versionNumber: string;
  readonly status: {
    readonly code: CatalogShareDetailsStatus;
    readonly label: string;
    readonly type: 'info' | 'success' | 'warning' | 'error' | 'neutral';
  };
  readonly creationDate: string;
  readonly createdBy: string;
  readonly activationDate?: string;
  readonly expirationDate?: string;
  readonly revocationDate?: string;
  readonly revokedBy?: string;
  readonly recipients: {
    readonly count: number;
    readonly emails: string[];
  };
  readonly failureReason?: string;
}
